import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RoutingStateService {
  private history = [];

  constructor(
    private router: Router
  ) {}

  public loadRouting(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(({urlAfterRedirects}: NavigationEnd) => {

        this.history = [...this.history, urlAfterRedirects];
        this.saveHistoryOnLocalStorage(urlAfterRedirects);
      });
  }

  public getHistory(): string[] {
    return this.history;
  }

  public getCurrentUrl(): string {
    return this.router.url;
  }

  public getPreviousUrl(): string {
    return this.history[this.history.length - 2] || this.getCurrentUrl();
  }

  private saveHistoryOnLocalStorage(url: string): void {
    const prev = this.getPreviousUrl()
    localStorage.setItem('historyUrl', JSON.stringify([prev, url]))
  }
}
